module.exports = __webpack_public_path__ + "static/media/Frascos.4617fac6.gif";